module.exports = __webpack_public_path__ + "img/cube.b5618029.svg";